import Guid from "~/helpers/guid";
import IRepo from "~/interfaces/repo";
import { IVisualizationRange } from "~/interfaces/visualizationInterfaces";
import TrackedModel from "~/models/tracked/trackedModel";
import Visualization from "~/models/visualizations/visualization";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";
import Repo from "~/state/modules/repo";
import { DateRangeType } from "../../../formability/visualizationBuilder/enums/dateRangeType";
import { RangeMode } from "../../../formability/visualizationBuilder/enums/rangeMode";
import Selected from "../../../formability/visualizationBuilder/store/modules/selected";
import VisualizationDataPoint from "./visualizationDataPoint";

export default class VisualizationRange extends TrackedModel implements IVisualizationRange {
  rootModel: Visualization;
  parent: VisualizationDataPoint;
  mode: RangeMode = RangeMode.number;
  value: number = null;
  inclusive: boolean = true;
  skip: boolean = false;
  repeat: boolean = false;
  date_value: string = null;
  error: string = '';
  date_range_type: DateRangeType = null;
  from_value: any;
  to_value: any;
  title: string = '';


  constructor(parent: VisualizationSourceDataPoint, json: any, rootVisualization = null) {   
    super();
    this.defineProperty("client_id", json.client_id || Guid.create());
    this.rootModel = rootVisualization || Selected.visualization.get();
    this.parent = parent;

    Object.keys(json).forEach(key => {
      this[key] = json[key]
    })
  }

  get index(): number {
    return this.parent.rangesArray.indexOf(this);
  }

  get adder(): number {
    if (this.inclusive) {
      return 0;
    }

    return this.parent.decimalPlaces ? parseFloat((1 / (10 ** this.parent.decimalPlaces)).toFixed(this.parent.decimalPlaces)) : 1;
  }

  get fromValue(): number {
    if (this.index === 0) {
      return this.value;
    }

    return this.parent.ranges[this.index - 1].toValue + this.adder;
  }

  get toValue(): number {
    if (this.inclusive) {
      return this.value;
    }

    return this.value - this.adder;
  }

  get rootName(): string {
    return 'ranges'
  }

  static repo: IRepo<VisualizationRange> = new Repo<VisualizationRange>('visualizationRanges', VisualizationRange, {});
  private _repo: IRepo<this>;
  public get repo(): IRepo<this> {
    return this._repo;
  }
  public set repo(value: IRepo<this>) {
    this._repo = value;
  }
}